import * as actionTypes from './action-types';
import initialState from '../../../initial-state';

export default function specificCourseReducer(state = initialState.specificCourse, action) {
  switch (action.type) {
    case actionTypes.LOAD_COURSES_SPECIFIC_COURSE:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case actionTypes.LOAD_COURSES_SPECIFIC_COURSE_SUCCESS:
      return {
        ...state,
        data: { ...action.result },
        isLoading: false,
      };
    case actionTypes.LOAD_COURSES_SPECIFIC_COURSE_FAIL:
      return {
        ...state,
        isLoading: false,
        hasError: true,
      };
    default:
      return state;
  }
}
